import React, { useRef } from "react"
import { motion, useInView, useReducedMotion } from "framer-motion"

type Props = {
  children: React.ReactNode
  className?: string
  delay?: number
}

const LandingReveal: React.FC<Props> = ({ children, className = "", delay = 0 }) => {
  const ref = useRef(null)
  const inView = useInView(ref, { once: true, margin: "-50px" })
  const prefersReducedMotion = useReducedMotion()

  return (
    <motion.div
      ref={ref}
      initial={prefersReducedMotion ? undefined : { opacity: 0, y: 28 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  )
}

export default LandingReveal
